/**
 * FILE: assets/quote-cart.js
 * 
 * Manages the quote list using localStorage.
 * Include this on all pages via theme.liquid:
 *   {{ 'quote-cart.js' | asset_url | script_tag }}
 */

const QuoteCart = {
  STORAGE_KEY: 'shopify_quote_cart',

  getItems() {
    try {
      return JSON.parse(localStorage.getItem(this.STORAGE_KEY)) || [];
    } catch {
      return [];
    }
  },

  saveItems(items) {
    localStorage.setItem(this.STORAGE_KEY, JSON.stringify(items));
    this.updateBadge();
    document.dispatchEvent(new CustomEvent('quote-cart:updated', { detail: { items } }));
  },

  addItem(product) {
    // product = { productId, variantId, title, variantTitle, image, price, handle }
    const items = this.getItems();
    const existing = items.find(
      i => i.variantId === product.variantId
    );
    if (existing) {
      existing.quantity = (existing.quantity || 1) + 1;
    } else {
      items.push({ ...product, quantity: 1 });
    }
    this.saveItems(items);
    this.showAddedFeedback(product.title);
  },

  removeItem(variantId) {
    const items = this.getItems().filter(i => i.variantId !== variantId);
    this.saveItems(items);
  },

  updateQuantity(variantId, quantity) {
    const items = this.getItems();
    const item = items.find(i => i.variantId === variantId);
    if (item) {
      item.quantity = Math.max(1, parseInt(quantity) || 1);
      this.saveItems(items);
    }
  },

  clearCart() {
    localStorage.removeItem(this.STORAGE_KEY);
    this.updateBadge();
    document.dispatchEvent(new CustomEvent('quote-cart:updated', { detail: { items: [] } }));
  },

  getCount() {
    return this.getItems().reduce((sum, i) => sum + (i.quantity || 1), 0);
  },

  updateBadge() {
    const count = this.getCount();
    document.querySelectorAll('[data-quote-count]').forEach(el => {
      el.textContent = count;
      el.style.display = count > 0 ? 'inline-block' : 'none';
    });
  },

  showAddedFeedback(title) {
    // Show a toast notification
    let toast = document.getElementById('quote-toast');
    if (!toast) {
      toast = document.createElement('div');
      toast.id = 'quote-toast';
      toast.style.cssText = `
        position: fixed; bottom: 24px; right: 24px; z-index: 9999;
        background: #1a1a2e; color: #fff; padding: 14px 20px;
        border-radius: 8px; font-size: 14px; box-shadow: 0 4px 20px rgba(0,0,0,0.3);
        transform: translateY(20px); opacity: 0;
        transition: all 0.3s ease; pointer-events: none;
      `;
      document.body.appendChild(toast);
    }
    toast.innerHTML = `
      ✓ <strong>${title}</strong> added to quote list.
      <a href="/pages/quote-request" style="color:#7eb8f7; margin-left:8px;">View Quote</a>
    `;
    toast.style.transform = 'translateY(0)';
    toast.style.opacity = '1';
    setTimeout(() => {
      toast.style.transform = 'translateY(20px)';
      toast.style.opacity = '0';
    }, 3500);
  },

  init() {
    this.updateBadge();

    // Handle "Request a Quote" button clicks on product pages
    document.addEventListener('click', (e) => {
      const btn = e.target.closest('.quote-request-btn');
      if (!btn) return;
      e.preventDefault();

      this.addItem({
        productId:    btn.dataset.productId,
        variantId:    btn.dataset.variantId,
        title:        btn.dataset.productTitle,
        variantTitle: btn.dataset.variantTitle,
        image:        btn.dataset.productImage,
        price:        btn.dataset.variantPrice,
        handle:       btn.dataset.productHandle,
      });

      // Visual feedback on button
      const span = btn.querySelector('span') || btn;
      const original = span.textContent;
      span.textContent = '✓ Added to Quote';
      btn.disabled = true;
      setTimeout(() => {
        span.textContent = original;
        btn.disabled = false;
      }, 2000);
    });
  }
};

document.addEventListener('DOMContentLoaded', () => QuoteCart.init());
